import { createFileRoute } from "@tanstack/react-router";
import TermsOfUse from "@/pages/TermsOfUse";

export const Route = createFileRoute("/_app/terms-of-use")({
  head: () => ({
    meta: [
      { title: "Terms of use | Byteline" },
      {
        name: "description",
        content:
          "The rules for using Byteline: accounts, acceptable use, content ownership, subscriptions and liability.",
      },
      { property: "og:title", content: "Terms of use | Byteline" },
      {
        property: "og:description",
        content: "Accounts, acceptable use, content ownership and subscriptions on Byteline.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <TermsOfUse />,
});
